interface SidebarCssVariables {
  // home theme
  homeSideBarColor: string;
  homeSideBarSectionFontColor: string;
  homeSideBarFontColor: string;
  homeSideBarSelectedColor: string;
  homeFooterBackgroundColor: string;
  homeFooterButtonSelectedColor: string;

  // admin theme
  adminSideBarColor: string;
  adminSideBarSectionFontColor: string;
  adminSideBarFontColor: string;
  adminSideBarSelectedColor: string;
  adminFooterBackgroundColor: string;
  adminFooterButtonSelectedColor: string;

  homeSideBarColorDefault: string;
  homeSideBarSectionFontColorDefault: string;
  homeSideBarFontColorDefault: string;
  homeSideBarSelectedColorDefault: string;
  homeFooterBackgroundColorDefault: string;
  homeFooterButtonSelectedColorDefault: string;

  adminSideBarColorDefault: string;
  adminSideBarSectionFontColorDefault: string;
  adminSideBarFontColorDefault: string;
  adminSideBarSelectedColorDefault: string;
  adminFooterBackgroundColorDefault: string;
  adminFooterButtonSelectedColorDefault: string;
}

export const SidebarCssVariable: SidebarCssVariables = {
  // home theme
  homeSideBarColor: "--home-sidebar-bg-color",
  homeSideBarSectionFontColor: "--home-sidebar-section-font-color",
  homeSideBarFontColor: "--home-sidebar-font-color",
  homeSideBarSelectedColor: "--home-sidebar-selected-menu-item-color",
  homeFooterBackgroundColor: "--home-footer-bg-color",
  homeFooterButtonSelectedColor: "--home-footer-button-selected-color",

  // admin theme
  adminSideBarColor: "--admin-sidebar-bg-color",
  adminSideBarSectionFontColor: "--admin-sidebar-section-font-color",
  adminSideBarFontColor: "--admin-sidebar-font-color",
  adminSideBarSelectedColor: "--admin-sidebar-selected-menu-item-color",
  adminFooterBackgroundColor: "--admin-footer-bg-color",
  adminFooterButtonSelectedColor: "--admin-footer-button-selected-color",

  homeSideBarColorDefault: "#4E5471",
  homeSideBarSectionFontColorDefault: "#FFFFFF",
  homeSideBarFontColorDefault: "#FFFFFF",
  homeSideBarSelectedColorDefault: "#707B96",
  homeFooterBackgroundColorDefault: "#1D283C",
  homeFooterButtonSelectedColorDefault: "#424B59",

  adminSideBarColorDefault: "#EFF3F4",
  adminSideBarSectionFontColorDefault: "#424B59",
  adminSideBarFontColorDefault: "#0071A1",
  adminSideBarSelectedColorDefault: "#FFFFFF",
  adminFooterBackgroundColorDefault: "#1D283C",
  adminFooterButtonSelectedColorDefault: "#424B59",
};

export default SidebarCssVariable;
